<template>
  <router-view v-slot="{ Component, route }">
    <a-config-provider
      :theme="{
        token: settingsStore.settings.resolved_theme
          ? {
              ...colors[settingsStore.settings.resolved_theme],
            }
          : {},
        algorithm:
          settingsStore.settings.resolved_theme === 'Dark'
            ? theme.darkAlgorithm
            : theme.defaultAlgorithm,
      }"
    >
      <!-- <Suspense> -->
        <component :is="route.meta.layout">
          <transition
            :name="route.meta.transition as string || 'fade'"
            mode="out-in"
          >
            <keep-alive>
              <component
                v-if="show"
                :is="Component"
                :key="$route.path"
              ></component>
            </keep-alive>
          </transition>
        </component>
        <!-- <template #fallback> Loading... </template>
      </Suspense> -->
      <contextHolder />
    </a-config-provider>
  </router-view>
</template>

<script setup lang="tsx">
import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
  onErrorCaptured,
  defineCustomElement,
} from 'vue'
import { RouterView } from 'vue-router'
import { Modal, theme } from 'ant-design-vue'
import {
  DeviceTypes,
  deviceEnquire,
  type DeviceType,
} from '@/libs/utils/device'
import { useSettingsStore } from '@/stores/settings'
import { useMenuStore } from '@/stores/menu'
import svgIcon from '@/components/core/svg-icon.ce.vue'
import ErrorPopup from './components/core/error-popup.vue'
import type { AppError } from './libs/errors/app-error'
import type { FetchError } from './libs/errors'
import { colors } from './colors'

const SvgElement = defineCustomElement(svgIcon)
customElements.define('c-svg', SvgElement)

const settingsStore = useSettingsStore()
const menuStore = useMenuStore()
const show = ref(true)

const [modal, contextHolder] = Modal.useModal()

window.modal = modal

function activate() {
  nextTick(() => (show.value = true))
}

function deactivate() {
  show.value = false
}

onUnmounted(deactivate)

onMounted(() => {
  activate()
  deviceEnquire((deviceType: DeviceType) => {
    settingsStore.setDevice(deviceType)
    if (deviceType === DeviceTypes.MOBILE) {
      menuStore.setVisibility(false)
      menuStore.setCollapsed(true)
    } else {
      menuStore.setVisibility(true)
      menuStore.setCollapsed(deviceType === DeviceTypes.TABLET)
    }
  })
})

const parsed_error = ref('')

async function parse_error(error: AppError | FetchError) {
  let data = { message: error.toString() }
  if ('metadata' in error) {
    try {
      const text = await error.metadata.response.text()
      try {
        data = JSON.parse(text)
      } catch (e) {
        data.message = text
      }
    } finally {
      parsed_error.value = data.message
    }
    return
  }
  parsed_error.value = data.message
}

onErrorCaptured((error: AppError) => {
  console.error(error)
  parse_error(error)
  modal.error({
    width: 800,
    type: 'error',
    content: () => (
      <ErrorPopup error={parsed_error.value} title={error.title}></ErrorPopup>
    ),
    icon: () => null,
    title: '',
  })
  return false
})
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
